<div class="tracker-detail mb20">
    <div class="trackerBg">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <app-vehicle-status></app-vehicle-status>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row trackerAccordion">
            <div class="col-sm-12 col-md-12 col-lg-12 mt-3 p-0">
                <div class="bg-white p-4">
                     <div *ngIf="isAppointmentOnHold" class="align-items-center font-weight-bold text-center font16  text-msg text-capitalize" translate>
                        lblThisAppointmentisonHold
                    </div>
                    <ngb-accordion #a="ngbAccordion" activeIds="{{activeId}}">
                        <ngb-panel id="first" *ngIf="showInvoiceSection && postedInvoiceList?.length > 0">
                            <ng-template ngbPanelHeader class="">
                                <div class="d-flex align-items-center trackerAccordion card-header">
                                    <button ngbPanelToggle translate aria-label="Center Align" class="btn d-flex w-100 align-items-center" translate>
                                      lblInvoice
                                        <ng-container *ngIf="!a.activeIds.includes('first')"><em
                                                class="fa fa-angle-down fa-lg ml-auto"></em>
                                        </ng-container>
                                        <ng-container *ngIf="a.activeIds.includes('first')"><em
                                                class="fa fa-angle-up fa-lg ml-auto"></em>
                                        </ng-container>
                                    </button>
                                </div>
                            </ng-template>
                            <ng-template ngbPanelContent>
                                <div class="row justify-content-center">
                                    <div class="col-12 col-sm-12 col-md-11 col-lg-10" *ngIf="serviceDetail?.invoicePriceLists?.length > 0; else NoRecords">
                                        <div class="d-flex my-3">
                                            <button class="btn btn-secondary ml-3 ml-auto" (click)="OnInvoicePayment(payment)" aria-label="Center Align" translate *ngIf="isPaymentFeatureEnable && isPaymentEnable">
                                                lblPayment
                                            </button>
                                        </div>
                                    </div>
                                    <ng-template #NoRecords>
                                        <div class="col-12 col-sm-12 col-md-11 col-lg-10">
                                            <div translate class="alert alert-warning mb-2 font18 text-center">
                                                lblNoRecordsFound</div>
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="row justify-content-center" *ngIf="postedInvoiceList?.length > 0" [style.paddingBottom]="'29px'">
                                    <div class="col-12 col-sm-12 col-md-11 col-lg-10">
                                        <h5 translate class="h5 font16 text-primary font-weight-bold heading py-2">
                                            lblInvoiceList
                                        </h5>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-11 col-lg-10">
                                        <div class="table-responsive">
                                            <table class="tablest1 fixed-header">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 5%" scope="col">#</th>
                                                        <th style="width: 5%" scope="col" translate>lblInvoiceNumber</th>
                                                        <th scope="col" translate>lblRegNumber</th>
                                                        <th scope="col" translate>lblVinNumber</th>
                                                        <th scope="col" translate>lblBillToCustomer</th>
                                                        <th scope="col" class="text-right" translate><span
                                                            translate>lblInvoiceAmount</span></th>
                                                        <th scope="col" class="text-right" translate><span
                                                            translate>lblInvoiceAmount</span><br><span class="text-sm1" translate>lblInclVAT</span></th>
                                                        <th style="width: 10%" scope="col" translate>lblDueDate</th>
                                                        <th style="width: 10%" scope="col" translate>lblPostedDate</th>
                                                        <th scope="col" translate>lblCreatedBy</th>
                                                        <th style="width: 5%" class="text-center" scope="col" translate>lblPreviewinvoice</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <ng-container *ngIf="postedInvoiceList?.length > 0; else load_else">
                                                        <tr *ngFor="let comm of postedInvoiceList; let i=index">
                                                            <td>{{i+1}}</td>
                                                            <td>
                                                                <ngb-highlight [result]="comm.invoiceNo"></ngb-highlight>
                                                            </td>
                                                            <td>
                                                                <ngb-highlight [result]="comm.licensePlateNo"></ngb-highlight>
                                                            </td>
                                                            <td>
                                                                <ngb-highlight [result]="comm.chassisNo"></ngb-highlight>
                                                            </td>
                                                            <td>
                                                                <ngb-highlight [result]="comm.billToCustomerName"></ngb-highlight>
                                                            </td>
                                                            <td class="text-right">{{comm.invoiceAmount| number:'1.2-2'}}</td>
                                                            <td class="text-right">{{comm.invoiceAmountVat| number:'1.2-2'}}</td>
                                                            <td>
                                                                <ngb-highlight [result]="comm.dueDate | date:'shortDate'"></ngb-highlight>
                                                            </td>
                                                            <td>
                                                                <ngb-highlight [result]="comm.postedDate | date:'shortDate'"></ngb-highlight>
                                                            </td>
                                                            <td>
                                                                <ngb-highlight [result]="comm.generatedBy"></ngb-highlight>
                                                            </td>
                                                            <td class="nowrap text-center">
                                                                <a class="btn btn-ico" ngbTooltip="{{'lblPreviewinvoice' | translate}}" (click)="onPreviewInvoice(comm.invoiceNo, previewModal)">
                                                                    <em class="far fa-eye fa-lg"></em>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                    <ng-template #load_else>
                                                        <tr>
                                                            <td colspan="14" class="no-record" translate>lblNoRecordsFound</td>
                                                        </tr>
                                                    </ng-template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ngb-panel>
                        <ngb-panel id="second" *ngIf="showShareboxSection && (contactDetails.isKeyDrop || contactDetails.isAutoKey)">
                            <ng-template ngbPanelHeader class="">
                                <div class="d-flex align-items-center trackerAccordion card-header">
                                    <button translate ngbPanelToggle translate aria-label="Center Align"
                                        class="btn d-flex w-100 align-items-center">
                                        lblShareboxDetail                                        <ng-container *ngIf="!a.activeIds.includes('second')"><em
                                                class="fa fa-angle-down fa-lg ml-auto"></em>
                                        </ng-container>
                                        <ng-container *ngIf="a.activeIds.includes('second')"><em
                                                class="fa fa-angle-up fa-lg ml-auto"></em>
                                        </ng-container>
                                    </button>
                                </div>
                            </ng-template>
                            <ng-template ngbPanelContent>
                                <div class="col-12"  [style.paddingBottom]="'29px'">
                                    <div class="af-form-group">
                                        <div class="af-form-group border">
                                            <div *ngIf="contactDetails.isKeyDrop">
                                                <h5 translate class="h5 font16 text-primary font-weight-bold heading py-2">
                                                    lblCustomerKeyDropInfo
                                                </h5>
                                                <div class="shareboxDetails">
                                                    <div class="af-form-group col-3">
                                                        <label translate>lblLocker</label>
                                                        <div class="lbl-info" *ngIf="customerKeyDropInfo">
                                                            {{customerKeyDropInfo.locationName}}\{{customerKeyDropInfo.lockerId}}
                                                        </div>
                                                    </div>
                                                    <div class="af-form-group col-3">
                                                        <label translate>lblAssignedLockerDate</label>
                                                        <div class="lbl-info" *ngIf="customerKeyDropInfo">
                                                            {{customerKeyDropInfo.assignLockerDate | date:'short'}}
                                                        </div>
                                                    </div>
                                                    <div class="col-3 af-form-group">
                                                        <label translate>lblKeyPickUpDate</label>
                                                        <div class="lbl-info" *ngIf="customerKeyDropInfo">
                                                            {{customerKeyDropInfo.keyPickUpDate | date:'short'}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="contactDetails.isAutoKey && isCustomerKeyPickInfo">
                                                <h5 translate class="h5 font16 text-primary font-weight-bold heading py-2">
                                                    lblCustomerKeyPickUpInfo
                                                </h5>
                                                <div class="shareboxDetails">
                                                    <div class="af-form-group col-3">
                                                        <label translate>lblLocker</label>
                                                        <div class="lbl-info" *ngIf="mechanicKeyDropInfo">
                                                            {{mechanicKeyDropInfo.locationName}}\{{mechanicKeyDropInfo.lockerId}}
                                                        </div>
                                                    </div>
                                                    <div class="af-form-group col-3">
                                                        <label translate>lblAssignedLockerDate</label>
                                                        <div class="lbl-info" *ngIf="mechanicKeyDropInfo">
                                                            {{mechanicKeyDropInfo.assignLockerDate | date:'short'}}
                                                        </div>
                                                    </div>
                                                    <div class="col-3 af-form-group">
                                                        <label translate>lblKeyPickUpDate</label>
                                                        <div class="lbl-info" *ngIf="mechanicKeyDropInfo">
                                                            {{mechanicKeyDropInfo.keyPickUpDate | date:'short'}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ngb-panel>
                        <ngb-panel id="third">
                            <ng-template ngbPanelHeader>
                                <div class="d-flex align-items-center trackerAccordion card-header">
                                    <button ngbPanelToggle translate aria-label="Center Align" class="btn d-flex w-100 align-items-center">
                                        lblYourOrder
                                        <ng-container *ngIf="!a.activeIds.includes('third')"><em
                                                class="fa fa-angle-down fa-lg ml-auto"></em>
                                        </ng-container>
                                        <ng-container *ngIf="a.activeIds.includes('third')"><em
                                                class="fa fa-angle-up fa-lg ml-auto"></em>
                                        </ng-container>
                                    </button>
                                </div>
                            </ng-template>
                            <ng-template ngbPanelContent>
                                <div [style.padding]="'0px 0px 29px'">
                                    <ng-container>
                                        <app-vehicle-order [OrderStatusDetail]="OrderStatusDetail"></app-vehicle-order>
                                    </ng-container>
                                </div>
                            </ng-template>
                        </ngb-panel>
                        <ngb-panel id="four">
                            <ng-template ngbPanelHeader>
                                <div class="d-flex align-items-center trackerAccordion card-header">
                                    <button ngbPanelToggle translate aria-label="Center Align" class="btn d-flex w-100 align-items-center">
                                        lblAdditionalService
                                        <ng-container *ngIf="!a.activeIds.includes('four')"><em
                                                class="fa fa-angle-down fa-lg ml-auto"></em>
                                        </ng-container>
                                        <ng-container *ngIf="a.activeIds.includes('four')"><em
                                                class="fa fa-angle-up fa-lg ml-auto"></em>
                                        </ng-container>
                                    </button>
                                </div>
                            </ng-template>
                            <ng-template ngbPanelContent>
                                <div [style.padding]="'0px 0px 29px'">
                                    <ng-container>
                                        <app-additional-service-info [OrderStatusDetail]="OrderStatusDetail"
                                    [setAdditionalServiceDetail]="additionalServiceDetail" [noRecords]="noRecords"
                                    ></app-additional-service-info>
                                    </ng-container>
                                </div>
                            </ng-template>
                        </ngb-panel>
                        <ngb-panel id="five">
                            <ng-template ngbPanelHeader>
                                <div class="d-flex align-items-center trackerAccordion card-header">
                                    <button ngbPanelToggle translate aria-label="Center Align" class="btn d-flex w-100 align-items-center">
                                        lblDealerInformation
                                        <ng-container *ngIf="!a.activeIds.includes('five')"><em
                                                class="fa fa-angle-down fa-lg ml-auto"></em>
                                        </ng-container>
                                        <ng-container *ngIf="a.activeIds.includes('five')"><em
                                                class="fa fa-angle-up fa-lg ml-auto"></em>
                                        </ng-container>
                                    </button>
                                </div>
                            </ng-template>
                            <ng-template ngbPanelContent>
                                <div [style.padding]="'0px 0px 29px'">
                                    <ng-container>
                                        <app-dealer-information></app-dealer-information>
                                    </ng-container>
                                </div> 
                            </ng-template>
                        </ngb-panel>
                        <ngb-panel id="six" *ngIf="showParkingSection && url !== null">
                          <ng-template ngbPanelHeader>
                            <div class="d-flex align-items-center trackerAccordion card-header">
                              <button ngbPanelToggle translate aria-label="Center Align" class="btn d-flex w-100 align-items-center">
                                lblPickupLocation
                                  <ng-container *ngIf="!a.activeIds.includes('six')"><em
                                          class="fa fa-angle-down fa-lg ml-auto"></em>
                                  </ng-container>
                                  <ng-container *ngIf="a.activeIds.includes('six')"><em
                                          class="fa fa-angle-up fa-lg ml-auto"></em>
                                  </ng-container>
                              </button>
                            </div>
                            </ng-template>
                            <ng-template ngbPanelContent>
                              <ng-container>
                                <div class="view-notification">
                                  <div class="container">
                                    <div class="row">
                                      <div class="col-lg-12 col-md-12">
                                        <div class="parkImage">
                                          <p class="m-0 py-2" translate>lblPickupLocationSentence</p>
                                          <img
                                            [src]="parkingImageToShow"
                                            alt="PickUp location image does not found."
                                            id="parkingPickUpImg"
                                            class="img-fluid imageresponse cursor-pointer"
                                          />
                                          <p class="m-0 py-2" translate>{{carParkingDetails?.Comments}}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                          </ng-template>
                        </ngb-panel>
                    </ngb-accordion>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #invoice let-modal>
    <div class="modal-header">
        <h2 class="modal-title" translate>lblPreviewinvoice</h2>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
            <span aria-hidden="true" class="font18">×</span>
        </button>
    </div>
    <div class="modal-body ">
        <div class="popup-vcenter ">
            <div class="head p-2 px-4">
                <div class="row d-flex align-items-center">
                  <div class="col-auto mr-auto">
                  </div>
                </div>
              </div>
            <div class="p-4 pdf-cnt ">
                <div class="row">
                    <div class="col-md-10">
                        <div class="row ">
                            <div class="col-md-3">
                                <p style="margin:0;"><strong style=" line-height: 1em !important;">
                                        {{contactDetails.customerName}}
                                    </strong>
                                </p>
                                <p style="margin:0; line-height: 1em !important;">{{contactDetails.address}}</p>
                            </div>
                            <div class="col-md-4">
                                <address style="line-height: 1em;" class="mb-2">
                                    <span style="line-height: normal;font-weight: bold;"> Dealer&nbsp; Address:</span>
                                    <br>
                                    {{contactDetails.dealerName}}<br />
                                    {{dealerDetails.address1}}<br />
                                    {{dealerDetails.address2}}
                                </address>
                                <address style=" line-height: 1em;" class="mb-2">
                                    <strong> Telephone:</strong> <br /><span
                                        style="font-size: .9em;">{{dealerDetails.mobile}}</span>
                                </address>
                            </div>
                            <div class="col-md-5">
                                <address style=" line-height: 1em;" class="mb-2">
                                    <strong> Date:</strong>
                                    <br /><span style="font-weight:normal;">{{TodayDate | date:'shortDate'}}</span>
                                </address>
                                <address style="font-size: .9em;  line-height: 1em;" class="mb-2">
                                    <strong style="font-size: .9em;"> E-mail: </strong>
                                    <br /><span
                                        style="font-weight:normal; word-break: break-all;">{{dealerDetails.email}}</span>
                                </address>
                                <address style=" line-height: 1em;" class="mb-2">
                                    <strong>Order&nbsp; Date:</strong>
                                    <br /><span style="font-weight:normal;">
                                        {{contactDetails.bookedDate}}
                                    </span>
                                </address>
                                <address style=" line-height: 1em;" class="mb-2"
                                    *ngIf="contactDetails && contactDetails?.isPickUpDropOffService">
                                    <strong>PickUp&nbsp; Time: </strong>
                                    <br /><span
                                        style="font-weight:normal; ">{{contactDetails.pickUpDateTime|date:'short'}}</span>
                                </address>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto ml-auto d-flex align-items-center">
                        <ng-container *ngIf="appointmentDetails && appointmentDetails.brand">
                            <img [src]="'../../../../../../assets/images/brandLogo/' + appointmentDetails.brandCode + '.png'"
                                height="35px" alt="">
                        </ng-container>
                    </div>
                </div>
                <ng-container *ngIf="previewType===1; else orderConfirmationWithPrice">
                    <div>
                        <div class="row mt-3" style="padding-bottom:5px !important; padding-top: 5px !important;">
                            <div class="col-md-12">
                                <h6><strong>Order&nbsp; Confirmation</strong></h6>
                                <p class="mt-3">
                                    We thank you for ordering a workshop appointment and confirm that we have set aside
                                    time for your
                                    <strong>{{contactDetails.modelName}} </strong>&nbsp;with registration number
                                    <strong>{{contactDetails.licensePlate}}</strong>.

                                </p>
                                <table class="table  mt-3">
                                    <thead>
                                        <tr style="background-color:lightgray;">
                                            <th scope="col" class="pl-1"
                                                style="font-weight: normal; background-color:lightgray; width: 40%; ">
                                                Ordered&nbsp;
                                                Services</th>
                                            <th scope="col" class=""
                                                style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;">
                                                Qty</th>
                                            <th scope="col" class=""
                                                style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;">
                                                Unit
                                                Price</th>
                                            <th scope="col" class=""
                                                style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;">
                                                Price
                                                without VAT</th>
                                            <th scope="col" class="pr-1"
                                                style="text-align: right;font-weight: normal; background-color:lightgray;border-left: none;">
                                                Price
                                                with VAT</th>
                                        </tr>
                                    </thead>

                                    <ng-container *ngIf="invoiceData?.length>0; else load_else">
                                        <tbody *ngFor="let data of invoiceData; let in=index" style="border: 0;">
                                            <tr>
                                                <th scope="col" colspan="4" class="font-weight-bold pl-1">
                                                    {{data.invoiceDemand.shortDescription}}

                                                    <ng-container *ngIf="data.invoiceDemand.fixedPrice"
                                                        class="font-weight-light">
                                                        &nbsp;(Fixed&nbsp;Price&nbsp;Job)
                                                    </ng-container>
                                                    <ng-container *ngIf="data.invoiceDemand.isInWarranty"
                                                        class="font-weight-light">
                                                        &nbsp;(In&nbsp;Warranty)
                                                    </ng-container>
                                                </th>
                                                <th scope="col" style="text-align: right;" class="pr-1">
                                                    <span
                                                        *ngIf="data.invoiceDemand.fixedPrice">
                                                        {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                                                    </span>
                                                </th>
                                            </tr>
                                            <tr *ngFor="let jobDetail of data.invoiceJobDetailsLists;">
                                                <td style="line-height: normal !important;" class="pl-1">
                                                    -&nbsp;{{jobDetail.description}}
                                                    <ng-container *ngIf="jobDetail.isFixedPrice"
                                                        class="font-weight-light">
                                                        &nbsp;(Fixed&nbsp;Price&nbsp;Job)
                                                    </ng-container>
                                                </td>
                                                <td style="text-align: right;">
                                                    <ng-container
                                                        class="font-weight-light">
                                                        {{jobDetail.plannedQuantity}}
                                                    </ng-container>
                                                </td>
                                                <td style="text-align: right;">
                                                    {{jobDetail.unitPrice | number:'1.2-2'}}
                                                </td>
                                                <td style="text-align: right;">
                                                    <ng-container *ngIf="jobDetail.isFixedPrice; else elsePriceExcVAT">
                                                        <ng-container
                                                            *ngIf="jobDetail.fixedPrice; else elseJobFixedPrice">
                                                            {{(data.invoiceDemand.isInWarranty ? 0 : jobDetail.fixedPrice) | number:'1.2-2'}}
                                                        </ng-container>
                                                        <ng-template #elseJobFixedPrice>
                                                            {{(data.invoiceDemand.isInWarranty ? 0 : data.invoiceJobLists[0].fixedPrice) | number:'1.2-2'}}
                                                        </ng-template>
                                                    </ng-container>
                                                    <ng-template #elsePriceExcVAT>
                                                        {{(data.invoiceDemand.isInWarranty ? 0 : jobDetail.salesPriceAmount) | number:'1.2-2'}}
                                                    </ng-template>
                                                </td>
                                                <td style="text-align: right;" class="pr-1">
                                                    <ng-container *ngIf="jobDetail.isFixedPrice; else elsePriceInclVAT">
                                                        <ng-container
                                                            *ngIf="jobDetail.fixedPrice; else elseJobFixedPriceInclVAT">
                                                            {{(data.invoiceDemand.isInWarranty ? 0 : jobDetail.fixedPrice) | number:'1.2-2'}}
                                                        </ng-container>
                                                        <ng-template #elseJobFixedPriceInclVAT>
                                                            {{(data.invoiceDemand.isInWarranty ? 0 : data.invoiceJobLists[0].fixedPrice) | number:'1.2-2'}}
                                                        </ng-template>
                                                    </ng-container>
                                                    <ng-template #elsePriceInclVAT>
                                                        {{(data.invoiceDemand.isInWarranty ? 0 : jobDetail.salesPriceAmountVAT) | number:'1.2-2'}}
                                                    </ng-template>
                                                </td>
                                            </tr>
                                            <tr style="border-bottom:1px solid black !important;border-top:1px solid black !important;"
                                                class="font-weight-bold">
                                                <td class="pl-1 pb-0 font-weight-bold">Sum</td>
                                                <td></td>
                                                <td></td>
                                                <td style="text-align: right;" class="font-weight-bold">


                                                </td>
                                                <td style="text-align: right;" class="pr-1 font-weight-bold">
                                                    <ng-container>
                                                        {{(data.invoiceDemand.isInWarranty ? 0 : data.invoiceDemand.sumPerServiceInclTax) | number:'1.2-2'}}
                                                    </ng-container>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </ng-container>
                                    <tbody style="border: 0;"  *ngIf="serviceDetail?.invoicePriceLists?.length > 0">
                                        <tr>
                                            <th scope="col"></th>
                                            <th scope="col" class="pl-1" colspan="3">
                                                Personnel Tax <span>({{contactDetails.personnelTax}}%)</span>
                                            </th>
                                            <th scope="col" class="text-right pr-1">
                                                {{ serviceDetail.invoicePriceLists[0].personnelTax | number:'1.2-2'}}
                                            </th>
                                        </tr>

                                        <tr>
                                            <th scope="col"></th>
                                            <th scope="col" class="pl-1" colspan="3">
                                                Material Tax <span>({{contactDetails.materialTax}}%)</span>
                                            <th scope="col" class="text-right pr-1">
                                                {{ serviceDetail.invoicePriceLists[0].materialTax | number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr class="font-weight-bold"
                                            style="border-bottom:1px solid black !important;border-top:1px solid black !important;">
                                            <th scope="col"></th>
                                            <th scope="col" class="pl-1 font-weight-bold" colspan="3">
                                                Sum
                                            </th>
                                            <th scope="col" class="text-right pr-1  font-weight-bold">
                                                {{
                                                serviceDetail.invoicePriceLists[0].materialTax+serviceDetail.invoicePriceLists[0].personnelTax
                                                |
                                                number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr style="border-bottom:1px solid black !important;">

                                            <th scope="col" class="pl-1 font-weight-bold ">
                                                Total&nbsp; Price&nbsp;
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col" class="text-right font-weight-bold pr-1">
                                                {{ serviceDetail.invoicePriceLists[0].totalPrice | number:'1.2-2'}}
                                            </th>
                                        </tr>

                                        <tr [hidden] = "true">
                                            <th scope="col" class="pl-1">
                                                Discount
                                                Applied({{serviceDetail.invoicePriceLists[0].customerDiscount}}%)
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col" class="text-right pr-1">
                                                {{serviceDetail.invoicePriceLists[0].discountedPrice | number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope="col" class="pl-1">
                                                Rounding
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col" class="text-right pr-1">
                                                <span *ngIf="showMinusRoundOff">-</span>
                                                {{ roundOff | number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr style="border-bottom:1px solid black !important;">
                                            <th scope="col" class="pl-1 font-weight-bold ">
                                                Total&nbsp;
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col" class="text-right font-weight-bold pr-1">
                                                {{ serviceDetail.invoicePriceLists[0].total | number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope="col" class="pl-1">
                                                Of which VAT ({{ serviceDetail.invoicePriceLists[0].vatPercentage}}%)
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col" class="text-right pr-1">
                                                {{ serviceDetail.invoicePriceLists[0].vatPrice | number:'1.2-2'}}
                                            </th>
                                        </tr>
                                    </tbody>

                                    <br />
                                    <tbody>
                                        <tr *ngIf="contactDetails.vehicleId" style="background-color:lightgray;">
                                            <th scope="col" style="font-weight: normal; background-color:lightgray;" class="pl-1">
                                                Rental Service</th>
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col" class="pr-1"
                                                style="text-align: right; font-weight: normal; background-color:lightgray;">
                                                Price
                                            </th>
                                        </tr>
                                        <tr *ngIf="contactDetails.vehicleId">
                                            <td translate class="pl-1">Rented Car - {{
                                                contactDetails.rentalCompanyMakeName }}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td style="text-align: right;" class="pr-1">
                                                {{contactDetails.price | number:'1.2-2' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">

                                <p>Contact us if you find that something is wrong, unclear or
                                    that someone is
                                    missing. Are you coming
                                    for something further you want done when the car is in the workshop, we ask you to
                                    contact
                                    in advance so that we can plan in both time and any parts to arrange it.</p>

                                <p class="mt-3">With best regards
                                </p>
                                <p>{{contactDetails.dealerName}}</p>
                                <div class="row mt-5">
                                    <div class="col-md-6">
                                        <p class="pt-3 pb-5">Digital signature</p>
                                        <p class="pt-3 pb-5">The customer's
                                            signature:________________________ </p>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </ng-container>
                <ng-template #orderConfirmationWithPrice>
                    <div>
                        <div class="row mt-4 orderConfirmation"
                            style="padding-bottom:5px !important; padding-top: 5px !important;">
                            <div class="col-md-12">
                                <h6><strong>Order&nbsp; Confirmation</strong></h6>
                                <p class="mt-2">
                                    We thank you for ordering a workshop appointment and confirm that we have set aside
                                    time for your
                                    <strong>{{contactDetails.modelName}}</strong>&nbsp; with registration number
                                    <strong>{{contactDetails.licensePlate}}.</strong>
                                </p>
                                <table class="table mt-3" style="border-spacing: 0;">
                                    <thead>
                                        <tr style="background-color:lightgray;">
                                            <th scope="col" class="pl-1"
                                                style="font-weight: normal; background-color:lightgray; width: 40%; ">
                                                Ordered&nbsp;
                                                Services</th>
                                            <th scope="col" class=""
                                                style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;">
                                            </th>
                                            <th scope="col" class=""
                                                style="text-align: right;font-weight: normal; background-color:lightgray;border-right: none;">
                                                Price
                                                without VAT</th>
                                            <th scope="col" class="pr-1"
                                                style="text-align: right;font-weight: normal; background-color:lightgray;border-left: none;">
                                                Price
                                                with VAT</th>
                                        </tr>
                                    </thead>

                                    <ng-container *ngIf="invoiceData?.length>0; else load_else">
                                        <tbody *ngFor="let data of invoiceData; let in=index" style="border: 0;">
                                            <tr>
                                                <th scope="col" colspan="3" class="font-weight-bold pl-1">
                                                    {{data.invoiceJobLists[0].description}}

                                                    <ng-container *ngIf="data.invoiceDemand.fixedPrice"
                                                        class="font-weight-light">
                                                        &nbsp;(Fixed Price Job)
                                                    </ng-container>

                                                </th>
                                                <th scope="col" style="text-align: right;" class="pr-1">
                                                    <span
                                                        *ngIf="data.invoiceDemand.fixedPrice && data.invoiceJobDetailsLists.length===0">
                                                        {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                                                    </span>
                                                </th>
                                            </tr>
                                            <tr *ngFor="let jobDetail of data.invoiceJobDetailsLists;">
                                                <td style="line-height: normal !important;" class="pl-1">
                                                    -{{jobDetail.description}}</td>
                                                <td></td>
                                                <td style="text-align: right;">
                                                    <ng-container *ngIf="jobDetail.isFixedPrice; else elsePriceExcVAT">
                                                        <ng-container
                                                            *ngIf="jobDetail.fixedPrice; else elseJobFixedPrice">
                                                            {{jobDetail.fixedPrice | number:'1.2-2'}}
                                                        </ng-container>
                                                        <ng-template #elseJobFixedPrice>
                                                            {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                                                        </ng-template>
                                                    </ng-container>
                                                    <ng-template #elsePriceExcVAT>
                                                        {{jobDetail.salesPriceAmount | number:'1.2-2'}}
                                                    </ng-template>
                                                </td>
                                                <td style="text-align: right;" class="pr-1">

                                                    <ng-container *ngIf="jobDetail.isFixedPrice; else elsePriceInclVAT">
                                                        <ng-container
                                                            *ngIf="jobDetail.fixedPrice; else elseJobFixedPriceInclVAT">
                                                            {{jobDetail.fixedPrice | number:'1.2-2'}}
                                                        </ng-container>
                                                        <ng-template #elseJobFixedPriceInclVAT>
                                                            {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                                                        </ng-template>
                                                    </ng-container>
                                                    <ng-template #elsePriceInclVAT>
                                                        {{jobDetail.salesPriceAmountVAT | number:'1.2-2'}}
                                                    </ng-template>
                                                </td>
                                            </tr>
                                            <tr style="border-bottom:1px solid black !important;"
                                                class="font-weight-bold">
                                                <td class="pl-1 pb-0 font-weight-bold">Sum</td>
                                                <td></td>
                                                <td style="text-align: right;" class="font-weight-bold">
                                                </td>
                                                <td style="text-align: right;" class="pr-1 font-weight-bold">
                                                    <ng-container
                                                        *ngIf="data.invoiceJobLists[0].fixedPrice; else elsePriceInclVATSum">
                                                        {{data.invoiceJobLists[0].fixedPrice | number:'1.2-2'}}
                                                    </ng-container>
                                                    <ng-template #elsePriceInclVATSum>
                                                        {{data.invoiceJobLists[0].salesPriceAmountVAT | number:'1.2-2'}}
                                                    </ng-template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </ng-container>

                                    <tbody style="border: 0;"  *ngIf="serviceDetail?.invoicePriceLists?.length > 0">
                                        <tr>
                                            <th scope="col">
                                            </th>
                                            <th scope="col" class="pl-1">
                                                Of which Personnel Tax <span>({{contactDetails.personnelTax}}%)</span>
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col" class="text-right pr-1">
                                                {{ serviceDetail.invoicePriceLists[0].personnelTax | number:'1.2-2'}}
                                            </th>
                                        </tr>

                                        <tr>
                                            <th scope="col"> </th>
                                            <th scope="col" class="pl-1">
                                                Of which Material Tax <span>({{contactDetails.materialTax}}%)</span>
                                            </th>
                                            <th scope="col"></th>
                                            <th scope="col" class="text-right pr-1">
                                                {{ serviceDetail.invoicePriceLists[0].materialTax | number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr class="font-weight-bold">
                                            <th scope="col"></th>
                                            <th scope="col" class="pl-1 font-weight-bold">
                                                Sum
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col" class="text-right pr-1 font-weight-bold">
                                                {{
                                                serviceDetail.invoicePriceLists[0].materialTax+serviceDetail.invoicePriceLists[0].personnelTax
                                                |
                                                number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr style="border-bottom:1px solid black !important;">

                                            <th scope="col" class="pl-1 font-weight-bold ">
                                                Total&nbsp; Price&nbsp;
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col" class="text-right font-weight-bold pr-1">
                                                {{ serviceDetail.invoicePriceLists[0].totalPrice | number:'1.2-2'}}
                                            </th>
                                        </tr>

                                        <tr [hidden] = "true">
                                            <th scope="col" class="pl-1">
                                                Discount Applied({{
                                                serviceDetail.invoicePriceLists[0].customerDiscount}}%)
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col" class="text-right pr-1">
                                                {{ serviceDetail.invoicePriceLists[0].discountedPrice | number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope="col" class="pl-1">
                                                Rounding
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col" class="text-right pr-1">
                                                <span *ngIf="showMinusRoundOff">-</span>
                                                {{ roundOff | number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr style="border-bottom:1px solid black !important;">
                                            <th scope="col" class="pl-1 font-weight-bold ">
                                                Total&nbsp;
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col" class="text-right font-weight-bold pr-1">
                                                {{ serviceDetail.invoicePriceLists[0].total | number:'1.2-2'}}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th scope="col" class="pl-1">
                                                Of which VAT ({{ serviceDetail.invoicePriceLists[0].vatPercentage}}%)
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col">
                                            </th>
                                            <th scope="col" class="text-right pr-1">
                                                {{ serviceDetail.invoicePriceLists[0].vatPrice | number:'1.2-2'}}
                                            </th>

                                        </tr>
                                    </tbody>

                                    <br />
                                    <tbody>
                                        <tr *ngIf="contactDetails.vehicleId" style="background-color:lightgray;">
                                            <th scope="col" style="font-weight: normal; background-color:lightgray;" class="pl-1">
                                                Rental Service</th>
                                            <th scope="col"></th>
                                            <th scope="col"></th>
                                            <th scope="col" class="pr-1"
                                                style="text-align: right; font-weight: normal; background-color:lightgray;">
                                                Price
                                            </th>
                                        </tr>
                                        <tr *ngIf="contactDetails.vehicleId">
                                            <td translate class="pl-1">Rented Car - {{
                                                contactDetails.rentalCompanyMakeName }}</td>
                                            <td></td>
                                            <td></td>
                                            <td style="text-align: right;" class="pr-1">
                                                {{contactDetails.price | number:'1.2-2' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>

                        </div>
                        <div class="row mt-3">
                            <div class="col-md-12">
                                <p>
                                    You can contact us if you find that something is wrong, unclear or that something is
                                    missing.
                                    If you come up with something more to be carried out when the car is in the
                                    workshop, then we ask you to
                                    contact us in advance so that we can plan for both time and any parts to fix it.
                                </p>
                                <p class="mt-3">
                                    With best regards,
                                </p>
                                <p>{{contactDetails.dealerName}}</p>
                                <div class="row mt-5">
                                    <div class="col-md-6">
                                        <p class="pt-3 pb-5"> Dealer's signature:__________________ </p>
                                    </div>
                                    <div class="col-md-6">
                                        <p class=" pt-3 pb-5">Customer's signature:__________________
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #payment let-modal>
    <div class="modal-header">
        <h2 class="modal-title" translate>lblPayment</h2>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">
            <span aria-hidden="true" class="font18">×</span>
        </button>
    </div>
    <div class="modal-body ">
        <div class="popup-vcenter ">
            <div class="head p-2 px-4">
                <div class="row d-flex align-items-center">
                  <div class="col-auto mr-auto">
                  </div>
                </div>
              </div>
            <div class="p-4 pdf-cnt ">
                <ng-container>
                    <div id="invoice-checkout-container">
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #previewModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblPreviewinvoice</h4>
        <button type="button" class="btn btn-secondary ml-auto mr-3" aria-label="Download-invoice"  *ngIf="invoiceFileContents" ngbTooltip="{{'lblDownloadInvoice' | translate}}" (click)="onDownloadInvoice()">
            <em class="fas fa-download fa-lg"></em>
        </button>
        <button type="button" class="close preview-close-btn" aria-label="Close" (click)="modal.dismiss(false)">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body" >
        <div *ngIf="trustedBlobUrl">
            <iframe id="fraDisabled" [src]="trustedBlobUrl" width="100%" height="700px" frameborder="0"></iframe>
          </div>
    </div>
</ng-template>
